export default __webpack_public_path__ + "static/concordiaLogo-62a78ade3e76948d03456c5cd37d78ee.png";